
export default {
  props: {
    item: { default: null },
    mode: { default: "" },
    localReviews: { default: () => [] },
    localSuggestions: { default: () => [] },
    showItem: { default: false },
    displayOnly: { default: false },
    reviewClasses: { default: "" },
    hasSuggestions: { default: false },
    paginate: { default: false },
    sortable: { default: false },
    desktopLimit: { default: 0 },
    mobileLimit: { default: 0 },
  },
  data() {
    return {
      reviews: [],
      suggestions: [],
      median: 0,
      newReview: { text: "", rating: 0 },
      lock: true,
      ratingFilter: null,
      showAll: false,
    };
  },
  computed: {
    currentLimit() {
      const m = this.$store.getters.isMobile;
      return +(m ? this.mobileLimit : this.desktopLimit) || 0;
    },
    filteredReviews() {
      if (this.ratingFilter == null) return this.reviews;
      return this.reviews.filter((r) => Math.round(r.rating) === this.ratingFilter);
    },
    displayedReviews() {
      if (!this.paginate || this.showAll || !this.currentLimit) return this.filteredReviews;
      return this.filteredReviews.slice(0, this.currentLimit);
    },
    hasMore() {
      return !this.showAll && this.currentLimit > 0 && this.filteredReviews.length > this.currentLimit;
    },
  },
  async mounted() {
    if ((this.localReviews || []).length) {
      this.reviews = this.localReviews;
    } else {
      if (this.mode == "full" || this.mode == "create") {
      }
      await this.getReviews();
      this.lock = (this.reviews || []).some(
        (r) => r.user._id == (this.$store.getters.user || {})._id
      );
    }
    if ((this.localSuggestions || []).length) {
      this.suggestions = this.localSuggestions;
    } else {
      this.getSuggestions();
    }
  },
  methods: {
    onControlChange() {
      this.$nextTick(() => this.$emit("layoutChanged"));
    },
    async getReviews() {
      let res;
      if(this.hasSuggestions){
        res = await this.$reviews.user(this.$store.getters.user._id)
      }else{
        res = await this.$reviews.get(this.item);
      }
      this.lock = res.docs.some(
        (r) => r.user._id == (this.$store.getters.user || {})._id
      );
      this.reviews = res.docs.filter(r=>r.item_id);
      this.median = res.median;
      this.getSuggestions();
    },
    async getSuggestions() {
      let res = await this.$reviews.suggestions(
        (this.$store.getters.user || {})._id,
        (this.$store.getters.user || {}).email
      );
      this.suggestions = res;
    },
    async removeReview(r) {
      let self = this;
      this.$clerk.hyperAlert({
        confirmButtonText: "Διαγραφή",
        title: "Διαγραφή αξιολόγησης;",
        html: "Η διαγραφή είναι οριστική και μη αναστρέψιμη.",
        callback: async (v) => {
          if (v) {
            await self.$reviews.remove(r);
            self.getReviews();
            self.$emit("remove");
          }
        },
      });
    },
    async createReview(newReview, item) {
      try {
        let res = await this.$reviews.create({
          item: this.item || item,
          ...(newReview || this.newReview),
        });
        this.$clerk.hyperAlert({
          title: "Ευχαριστούμε",
          html: "Η αξιολόγησή σας τοποθετήθηκε με επιτυχία. Αναμένεται αποδοχή από τους διαχειριστές. Ευχαριστούμε.",
          icon: "success",
          cancelShow: false,
          confirmButtonText: "Συνέχεια",
        });
        this.newReview = { text: "", rating: 0 };
        if (newReview) {
          newReview.text = "";
          newReview.rating = 0;
          this.getReviews();
          this.getSuggestions();
        }
      } catch (error) {
        console.error(error);
        if (((error.response || {}).data || {}).message == "already") {
          this.$clerk.hyperAlert({
            time: 12000,
            icon: "warning",
            html: "Έχετε ήδη αξιολογήσει το προϊόν αυτό.<br> Σε περίπτωση που δεν το βλέπεται περιμένει έγκριση από τον διαχειριστή.",
          });
          return;
        } else if (((error.response || {}).data || {}).message == "buy") {
          this.$clerk.hyperAlert({
            time: 12000,
            icon: "warning",
            html: "Δεν έχετε πραγματοποιήσει αγόρα στο συγκεκριμένο προϊόν ακόμη.",
          });
          return;
        }
        this.$clerk.hyperAlert({
          time: 10000,
          icon: "warning",
          html: "Η αξιολόγηση δεν καταχωρήθηκε.<br> Δοκιμάστε ξανά αργότερα.",
        });
      }
    },
  },
};
